export const PaymentTypes = {
  CREDIT_CARD: '3',
  TWO_CARDS: 'twoCards'
}